<template>
  <div class="login">
    <div class="login-main">
      <div class="flx flx-col login-top">
        <img src="@/assets/images/login/login-top-img-01.webp" alt="login-image-top">
        <img src="@/assets/images/login/login-top-img-02.webp" alt="login-image-bottom">
      </div>
      <div class="flx flx-col login-bottom">
        <div class="flx flx-col input-wrap">
          <input type="text" placeholder="아이디(이메일) (@ 이하 모두 입력)" v-model="loginId" @keyup.enter="clickLogin()">
          <label class="input-password">
            <input type="password" placeholder="비밀번호 (영문, 숫자, 특수문자 포함 8~18자)" autocomplete="off" v-model="loginPw" @keyup.enter="clickLogin()">
            <!-- TODO: hide추가시 눈모양 오픈 -->
            <span class="eye" @click="changePwType($event)"></span>
          </label>
<!--          TODO: ID 저장 숨김-->
<!--          <div class="flx flx-row checkbox-wrap">-->
<!--            <label class="checkbox">-->
<!--              <input type="checkbox" v-model="idStore" @click="checkStoreId()">-->
<!--              <span class="checkmark"></span>-->
<!--              <span class="label">아이디 저장</span>-->
<!--            </label>-->
<!--            <label class="checkbox">-->
<!--              <input type="checkbox" v-model="loginStore" @click="checkStoreLogin()">-->
<!--              <span class="checkmark"></span>-->
<!--              <span class="label">자동 로그인</span>-->
<!--            </label>-->
<!--          </div>-->
        </div>

        <button class="submit big-button" :disabled="loginId.length < 1 || loginPw.length < 1" @click="clickLogin()">로그인</button>

        <div class="flx flx-col find-wrap">
          <div class="flx flx-row">
            <p><router-link :to="{ name : 'searchId' }">아이디 찾기</router-link></p>
            <div class="bar"></div>
            <p><router-link :to="{ name : 'searchPw' }">비밀번호 찾기</router-link></p>
          </div>
          <p class="login-info">회원가입은 슈퍼V 홈페이지를 이용해주세요.</p>
        </div>
      </div>
      <div class="copyright">Copyright 2022 by growV. All Rights Reserved.</div>
    </div>
  </div>
  <mainGuideModal :propsData="{mainGuideShowModal}" @closePopup="closePopup"></mainGuideModal>
</template>

<script>
import {setCookie} from '@/common/common';
import {login} from "@/api/auth/auth-api";
import {mapActions, mapGetters} from 'vuex'
import jwt from "@/common/jwt";
import changePwTypeMixin from '@/common/mixin/changePwTypeMixin';
import mainGuideModal from '../../auth/login/comp/comp-login-popup/comp-main-guide.vue';

export default {
  mixins: [changePwTypeMixin],
  data() {
    return {
      loginId: '',
      loginPw: '',
      idStore: false,
      loginStore: false,
      //  TODO: 메인 가이드 화면
      mainGuideShowModal: false,
    }
  },
  components: { mainGuideModal },
  computed: {
    ...mapGetters(['userInfo','getProductInfo']),
  },
  created() {
    this.getEmailCookie();
    this.isFirst();
  },
  methods: {
    ...mapActions(['loadProductInfo']),

    // 아이디 저장 체크
    checkStoreId() {
      this.idStore = !this.idStore;
    },
    // checkStoreLogin() {
    //   this.loginStore = !this.loginStore;
    // },
    // 아이디 저장 되어있으면 아이디 조회
    getEmailCookie() {
      let val = document.cookie.match(new RegExp('(^| )parentAppUserEmail=([^;]+)'));
      if (val) {
        this.loginId = val[2];
      }
      // let ls = document.cookie.match(new RegExp('(^| )loginStore=([^;]+)'));
      // if (ls) {
      //   this.loginStore = false;
      //   this.doAutoLogin();
      // }
      this.doAutoLogin();
    },
    doAutoLogin() {
      if (!jwt.isExpired()) {
        this.$router.push('/main');
      }
    },
    // 팝업 닫기 공통
    closePopup() {
      this.mainGuideShowModal = false;
      document.querySelector('body').style.overflow = 'auto';
    },
    // 로그인
    async clickLogin() {
      // 아이디 저장이 체크되어 있는지 여부에 따른 코드
      if (this.idStore) {
        let userEmail = this.loginId;
        setCookie("parentAppUserEmail", userEmail, 7);
      } else {
        setCookie("parentAppUserEmail", "", -1);
      }
      // 자동 로그인 체크
      if (this.loginStore) {
        setCookie("loginStore", 'Y', 30);
      } else {
        setCookie("loginStore", 'N', -1);
      }

      const credentials = {
        email: this.loginId,
        password: this.loginPw,
      }

      try {
        const res = await login(credentials);
        const result = res.data;

        if (result.code === '200') {
          if (result.data.accessToken) {
            jwt.saveAllToken(result.data);
            this.$store.dispatch('loadUserInfo');

            setTimeout(() => {
              this.loginPageTransfer();
            }, 500)
          } else {
            console.log('엑세스토큰없는경우');
          }
        } else {
          alert('로그인 정보를 확인할 수 없습니다. 계정 정보를 다시 확인해주시기 바랍니다.');
          jwt.destroyAll();
        }
      } catch(error) {
        console.log(error);
      }
    },
    loginPageTransfer() {
      if (!this.userInfo.info.tempChangeYn) { // 임시회원(false) 회원전환 프로세스 처리
        console.log("임시회원 전환 가입 페이지 이동");
        // 슈퍼브이 회원가입 페이지 새창으로 연결
        if(confirm('슈퍼브이 홈페이지에서 회원가입 후 로그인 가능합니다. 회원가입 하시겠습니까?')) {
          // eslint-disable-next-line
          GrowvParentsBridge.openInBrowser('https://www.superv.com/member/signup.html')
        }
      } else if (this.userInfo.info.tempChangeYn) { // 정회원(true)이면 메인페이지로 이동
        // 학부모앱 메인페이지 화면전환
        this.$router.push({ name: 'mainStudyTab' });
      } else { // 유효하지 않은 회원 상태로 처리
        console.log("유효하지 않은 회원 상태로 처리");
        jwt.destroyAll();
      }
    },
    isFirst() {
      if (localStorage.getItem('is_pmafirst') === 'Y') {
        return;
      } else {
        localStorage.setItem('is_pmafirst','Y')
        this.mainGuideShowModal = true;
      }
    },
  },
}
</script>

<style scoped lang="scss">
  //@import "@/assets/scss/page/login.scss";
</style>